import { useEffect } from "react";
import { useColorMode } from "@chakra-ui/react";

export default function ColorModeSync() {
  const { colorMode } = useColorMode();
  useEffect(() => {
    document.body.setAttribute("data-theme", colorMode); // "dark" or "light"
  }, [colorMode]);
  return null;
}
